import {
  ComparatorContext,
  GraphLegacyApiService,
  IProduct,
  useField,
} from '@kizi/comparator-core';
import { Image, P } from '@kizi/core-components';
import React, { useContext, useEffect, useState } from 'react';
import { Window } from '../../Window';
import { Modal } from './Modal';
import { FeaturesTab } from './FeaturesTab';

interface ProductModalProps {
  data: IProduct;
  buttonText?: string;
}

function extractIdFromKRN(krn) {
  const parts = krn.split('/');
  const id = parts[parts.length - 1];
  return Number(id);
}
function getRefKeys(homePackage) {
  return homePackage.policyPolicyDetails.map((policy) => Number(policy.refKey));
}

function mapEdges(edges) {
  const categories = {};

  edges.forEach((edge) => {
    const { category, name, details } = edge.node;

    if (!categories[category]) {
      categories[category] = [];
    }

    categories[category].push({
      name,
      details,
    });
  });

  return categories;
}

interface Feature {
  name: string;
  details: string;
}

interface FeatureCategories {
  [category: string]: Feature[];
}

export const ProductModal: React.FC<ProductModalProps> = ({
  data,
  buttonText = 'Open Modal',
}) => {
  const { image, provider, productCode } = data;
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(!isOpen);
  const { api } = useContext(ComparatorContext);
  const [features, setFeatures] = useState<FeatureCategories>();
  const coverageTypeField = useField('coverages.coveragetype');

  useEffect(() => {
    async function fetchData() {
      try {
        const productIds =
          coverageTypeField?.value === '3'
            ? getRefKeys(data.homePackage)
            : extractIdFromKRN(productCode);
        const features = await (
          api as GraphLegacyApiService
        ).getHomeFeaturesDetails(productIds, null);
        if (features.edges) {
          const featureCategories = mapEdges(features.edges);
          setFeatures(featureCategories);
        }
      } catch (error) {
        console.error('Error fetching features:', error);
      }
    }

    fetchData();
  }, [api, coverageTypeField, data, productCode]);
  const tabs = [
    {
      label: '',
      content: <FeaturesTab data={features} />,
    },
  ];

  return (
    <>
      <P
        onClick={handleOpen}
        variant="footnoteImportant"
        color="main.1"
        css={{ cursor: 'pointer' }}
        display="inline-block"
      >
        {buttonText}
      </P>

      <Window
        type="modal"
        onClose={handleOpen}
        show={isOpen}
        showIcon
        title={
          <Image
            src={image}
            width="100%"
            height="100%"
            maxWidth={150}
            alt={`logo-${provider.name}`}
          />
        }
        modalProps={{
          show: isOpen,
          modalContainerDivProps: {
            width: '80% !important',
            maxWidth: '760px',
          },
          children: <Modal tabs={tabs} selectedTabIndex={0} data={data} />,
        }}
      >
        {/* Mobile */}
        <Modal tabs={tabs} selectedTabIndex={0} data={data} />
      </Window>
    </>
  );
};
